import { connect } from 'react-redux'

import { getIsSyncing } from '../VNSyncManager/Selectors'

import Navbar from '../components/Navbar'

import { setShouldUpdate } from '../VNUpdateManager/ActionCreators'

const mapStateToProps = (state) => {
  const isSyncInProgress = getIsSyncing(state)

  return { isSyncInProgress }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setShouldUpdate: () => dispatch(setShouldUpdate()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Navbar)
